import { trackingEvent } from '@notino/web-tracking';

import { IUser } from '@model';

import { dispatchEcommerceMessage } from '../../../messagingService';
import { EcommerceSectionNamespace, EItemGroup, IEcommerceCheckout } from '../../model';

export const trackDeloitteCartPageView = ({ products }: IEcommerceCheckout, { cart, sessionId }: IUser) => {
  const filteredProducts = products.filter((p) => p.price > 0 && p.group === EItemGroup.PRODUCT); //remove gifts, only products

  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.CLOUD_RETAIL,
      cloud_retail: {
        eventType: EcommerceSectionNamespace.EEcommerceEvent.SHOPPING_CART_VIEW,
        visitorId: sessionId,
        eventTime: new Date().toISOString(),
        productDetails: filteredProducts.map((product) => ({
          product: {
            id: product.productCode,
          },
          quantity: product.quantity,
        })),
        cartId: cart,
      },
    }),
  );
};
